import Appsignal from '@appsignal/javascript'

import config, { appsignalKey } from '~/config'

export default new Appsignal({
  key: appsignalKey,
  revision: config.RELEASE_NAME,
})
